export default {
  slides: [
  ],

  slidesIOS: [
  ],

  searchStatus: false,
  menuStatus: false,
  loading: true,
  screenSwiped: false,
  people: [],
  offset: 0
}
